import { WidgetsSplitDetailMain } from '@/widgets/split-detail';

export const PagesSplitDetailMain = () => <WidgetsSplitDetailMain />;
